module.exports = __webpack_public_path__ + "static/media/camila-mesquita.50d47de6.png";